// Does fullText contain all the specified parts?
export function containsAll(fullText: string|undefined, partsToMatch: string[]|undefined, options: { matchCaseInsensitive: boolean } = {matchCaseInsensitive: true}): boolean
{
    // If we don't have enough to perform a match, assume we have a match
    if (undefined === partsToMatch || 0 === partsToMatch.length)
        return true;

    if (undefined === fullText || "" === fullText)
        return false;

    if (options?.matchCaseInsensitive)
    {
        fullText = fullText.toLowerCase();

        partsToMatch = partsToMatch.map(p => p.toLowerCase());
    }

    for(const part of partsToMatch)
    {
        if (!fullText.includes(part))
            return false;
    }

    return true;
}
